module.exports = __webpack_public_path__ + "static/media/KHOF08.7625b8b1.jpg";